module.exports = __webpack_public_path__ + "static/img/wbtj-title.0424d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/wbtj-title.png
// module id = Odnp
// module chunks = 1